import type { TOC } from '@ember/component/template-only';
import { eq } from 'ember-truth-helpers';
import UiButtonGroup from 'garaje/components/ui/button-group';

export interface SettingsPanelFooterSignature {
  Args: {
    style?: string;
    vertical?: boolean;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

export default <template>
  <UiButtonGroup
    class={{if (eq @style "inset") "ml-16" "float-right"}}
    @vertical={{@vertical}}
    data-test-settings-panel-footer
    ...attributes
  >
    {{yield}}
  </UiButtonGroup>
</template> satisfies TOC<SettingsPanelFooterSignature>;
